import { getCookie, removeCookie, setCookie } from '../cookies';

/**
 * Cookie holding the verified uploader's opaque access token. Scoped to
 * `/upload` so a single verified session is shared across every upload link id
 * and across tabs. It is a session cookie: expiry is owned entirely by the
 * backend, which rejects a stale token with UNAUTHENTICATED. A stale token is
 * cleared when an upload attempt comes back unauthenticated (see UploadQueue),
 * not on every UNAUTHENTICATED response.
 */
export const UPLOAD_ACCESS_TOKEN_COOKIE = 'frameio-upload-access-token';

const COOKIE_OPTIONS = {
  path: '/upload',
  secure: true,
  sameSite: 'lax',
} as const;

export function setAccessToken(token: string): void {
  setCookie(UPLOAD_ACCESS_TOKEN_COOKIE, token, COOKIE_OPTIONS);
}

export function getAccessToken(): string | undefined {
  return getCookie(UPLOAD_ACCESS_TOKEN_COOKIE);
}

export function clearAccessToken(): void {
  removeCookie(UPLOAD_ACCESS_TOKEN_COOKIE, { path: '/upload' });
}
